import km from 'keymirror'
import _ from 'underscore'

const env = process.env || 'development'
console.log('env: ', env)
const cookieMaxage = 1000*60*60*24*30*12 // 6个月
export default _.extend({
  ORIGIN_HOST: env === 'production' ? 'https://m.sdyxmall.com'
    : env === 'preview' ? 'http://pre-m.sdyxmall.com' : 'http://dev-m.sdyxmall.com',
  REQUEST_HOST: env === 'production' ? '/gateway'
    : env === 'preview' ? '/gateway' : '/gateway',
  COOKIE_DEFAULT_DOMAIN: env === 'production' ? '.m.sdyxmall.com' : env === 'preview' ? '.pre-m.sdyxmall.com' : '.dev-m.sdyxmall.com',
  COOKIE_DEFAULT_MAXAGE: cookieMaxage,
  COOKIE_DEFAULT_PATH: '/',
  COOKIE_CO: 'co',
  COOKIE_CPS_ID: 'cpsCode',
  COOKIE_DEFAULT_CO: 'sdyx',
  COOKIE_CO_IS_SDYXVIP: 'sdyx-vip',
  COOKIE_CO_IS_SDYC: 'sdyx-yc',
  COOKIE_CO_IS_MZVIP: 'sdyx-mzvip',
  COOKIE_CO_IS_MZAPP: 'sdyx-mzapp',
  COOKIE_CO_IS_QYG: 'sdyx-qyg',
  COOKIE_CO_IS_MP_SDTJ: 'mp-sdtj',
  COOKIE_SDYC_CALLBACK_URL: 'callBackUrl',
  COOKIE_QYG_CALLBACK_URL: '/v1/?co=sdyx-qyg#/global/515',
}, km({
  COOKIE_PRODUCT_ID_FOR_PREORDER: null,
  COOKIE_SERVICE_TIME: null,
  COOKIE_USER_ID: null,
  COOKIE_USER_NAME: null,
  COOKIE_USER_MOBILE: null,
  COOKIE_USER_X_TOKEN: null,
  COOKIE_CITY_ID: null,
  COOKIE_CITY_NAME: null,
  COOKIE_CARD_AUTH_TOKEN: null,
  COOKIE_USER_THIRD_OPENID: null,
  COOKIE_USER_THIRD_TYPE: null,
  COOKIE_USER_INFO_HAS_PASSWORD: null,
  COOKIE_DEFAULT_SDYX_OPENID: null,
  COOKIE_USER_INFO_HAS_PAY_PASSWORD: null,
  DEVICE_ID: null,
  COOKIE_PRODUCT_DELIVERY: null, // 商详页：用户选择的商品适用配送地址
  COOKIE_LOCAL_CITY_ID: null,   // gps定位城市id
  COOKIE_LOCAL_CITY_NAME: null,
  COOKIE_V2_CITY_ID: null,  // 用户选择城市id
  COOKIE_V2_CITY_NAME: null,
  COOKIE_CITY_FIRST_CHECK_CONFIRM: null,

  COOKIE_DEFAULT_SHIPPING_ADDRESS_CITY_ID: null, // 收货地址选择城市id
  COOKIE_DEFAULT_SHIPPING_ADDRESS_CITY_NAME: null, // 收货地址选择城市name
  COOKIE_DEFAULT_SHIPPING_ADDRESS: null, // 默认定位地址
  COOKIE_USER_SELECT_SHIPPING_ADDRESS: null, // 用户选择的定位地址

  COOKIE_USER_SELECT_ADDRESS_BY_ADD: null, // 用户新增地址选择的地址
  COOKIE_ADDRESS_FORM_VALUE: null, // 缓存新增地址信息,

  COOKIE_CURRENT_ZONE_ID: null, // 专区品类id
  COOKIE_USER_COMPANY: null, // 企业用户绑定企业
}))
